import { LeadworkflowConfigJson } from "../../../../../../types"

export const DEFAULT_TXT_MSGS_DISCLAIMER =
  "I agree to receive text messages regarding mortgage rate updates, loan information, and related services. Message and data rates may apply. Reply STOP to unsubscribe."

/** Syncs disclaimers.txt_msgs — preserves custom edits when toggled on. */
export const syncTxtMsgsDisclaimer = (
  config: LeadworkflowConfigJson
): LeadworkflowConfigJson => {
  const show = config.show_txt_msgs_disclaimer === true
  const { txt_msgs, ...restDisclaimers } = config.disclaimers ?? {}

  return {
    ...config,
    show_txt_msgs_disclaimer: show,
    disclaimers: show
      ? {
          ...restDisclaimers,
          txt_msgs: txt_msgs || DEFAULT_TXT_MSGS_DISCLAIMER
        }
      : restDisclaimers
  }
}
